import { Text } from "@meditect/medibase-components";

export const UserInvalidPhoneNumberError = (): React.ReactElement => {
  return <Text>Le numéro de téléphone renseigné est invalide</Text>;
};
